import {BackendEndpoints} from './BackendEndpoints'
import {getApiBaseFromBackendUrl} from './getApiBaseFromBackendUrl'

export const getV1BaseFromBackendUrl = (backendUrl: string): string => {
    return getApiBaseFromBackendUrl(backendUrl, BackendEndpoints.V1)
}
